// Vocabulário único dos papéis. Qualquer tela que nomeie ou descreva um papel deve usar este módulo.
export const ROLE_LABELS = ['Leitor', 'Gestor', 'Administrador'] as const

export const ROLE_DESCRIPTIONS = [
  'Lê os comunicados e confirma a ciência quando for pedido.',
  'Publica comunicados e acompanha quem leu. Também cuida das lojas e dos departamentos.',
  'Faz tudo o que o Gestor faz e também cuida das pessoas, do histórico de ações e da identidade visual.',
] as const

export function roleLabel(role?: string | number | null) {
  switch (String(role ?? '').toUpperCase()) {
    case '2':
    case 'ADMIN':
      return ROLE_LABELS[2]
    case '1':
    case 'MANAGER':
      return ROLE_LABELS[1]
    case '0':
    case 'USER':
      return ROLE_LABELS[0]
    default:
      return role ? String(role) : ''
  }
}
